import styled from 'styled-components';

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
  height: 100%;
`;
const StyledInfoWindow = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  background-color: white;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0; 
  padding: 1.5rem; 
  width: 35rem; 

  @media (max-width: 1200px) {
    width: 28rem;
  }
  @media (max-width: 900px) {
    width: 22rem;
  }
  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    padding: 1rem;
  }
`;

const StyledFieldNameBlock = styled.p`
  text-align: left;
  margin: 0;
  color: #052959;
  font-weight: 500;
`;

const StyledInfoBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: var(--color-secondary-text);
  padding: 10px 0;
  width: 100%;
  span {
    padding: 1px 6px;
    }
`;
const ScheduleHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
` ;

const StyledSearchButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  font-size: 0.875rem; 
  font-weight: 700; 
  outline: none;
  height: 2.25rem;
  padding: 0.5rem 1rem; 
  width: 100%; 
  background-color: #395905; 
  color: #fff;  
  cursor: pointer; 
  border: none;

  &:hover {
    background-color: #052959;
  }
`;

const AddContactButton = styled.button`
  margin-top: 0.5rem;
  padding: 0.4rem 0.5rem;
  color: #fff;
  border: none;
  font-weight: 500;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s;
  background-color: #395905; 

  &:hover {
    background-color: #052959;
  }
`;

const StyledTitle = styled.h2`
  padding: 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  font-family: 'Manrope', sans-serif;
  color: var(--color-primary);
  text-align: center;
  padding-bottom: 0.75rem;
`;

const ValidationMessage = styled.div`
  color: #a6031f
  font-size: 0.875rem;
  padding: 0.75rem;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 0.375rem;
  margin: 1rem 0;
  text-align: center;
  font-family: 'Manrope', sans-serif;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
`;



export {
  StyledButtonWrapper,
  StyledInfoWindow,
  StyledFieldNameBlock,
  StyledInfoBlock,
  StyledSearchButton,
  AddContactButton,
  ValidationMessage,
  StyledFooter,
  StyledTitle,
  StyledHeader,
  ScheduleHeaderWrapper
};
